import { inject, injectable } from 'inversify'
import { TYPES } from '@/libs/di/types'
import { APIError } from '@/libs/utilities/CustomErrors'

import type { AccountRepository } from '@/apis/usecases/dataAccesses'
import type { SessionResponse } from '@/apis/repositories/models/bigbrother'
import type { BigbrotherClient, HotelClient } from '@/apis/infrastructures'

@injectable()
export class AccountRepositoryImpl implements AccountRepository {
  @inject(TYPES.BigbrotherClient) private _bigbrotherClient: BigbrotherClient
  @inject(TYPES.HotelClient) private _hotelClient: HotelClient

  public async postLogout() {
    await this._hotelClient.post('/planner/logout/')
  }

  public async updateSession() {
    const { data } =
      await this._bigbrotherClient.get<SessionResponse>('/session')
    return {
      shortSessionId: data.ShortSession.ID,
      longSessionId: data.LongSession.ID,
    }
  }

  public async requestLogin(payload: { email: string; password: string }) {
    const {
      data: { token, ok },
    } = await this._hotelClient.post<{ token: APIToken; ok: boolean }>(
      '/planner/login/',
      payload
    )
    if (!ok) {
      throw new APIError(401, 'Unauthorized')
    }
    return token
  }
}
